// UraniumSeg1 — Part 1 sliding "10 g URANIUM = 1 TONNE COAL = 149 GAL OIL = 17,000 FT³ GAS = 6 WEEKS HOME ELEC"
//
// All visual mechanics live in overlayKit/ComparisonChain. This file is purely DATA:
//   • the constant term (the 10 g uranium tag, count-up timing)
//   • each frame the constant slides through (panel layout + arrival time)
//   • the equivalents shown in each frame (label/value, fade-in/out times, color)
//
// Production-universal-ready: any production with the same "constant + sliding equivalents"
// pattern can mirror this file — only the data differs.
import React from "react";
import { AbsoluteFill } from "remotion";
import { ComparisonChain, PaletteProvider } from "./overlayKit";
import { URANIUM_PALETTE } from "./UraniumPalette";

export const UraniumSeg1: React.FC = () => (
  <PaletteProvider value={URANIUM_PALETTE}>
    <AbsoluteFill>
      <ComparisonChain
        constant={{
          label: "URANIUM",
          suffix: " g",
          count: { from: 0, to: 10, atS: 3.13, endS: 3.77 },
          color: "primary",
          fadeInS: 2.2,
          fadeInDurS: 0.35,
        }}
        frames={[
          // Frame 1 — center, hero close-up of the pellet (no equivalents).
          { layout: "center", landAt: 0, equivalents: [] },

          // Frame 2 — split-screen: pellet on left, coal heap on right.
          {
            layout: "left-half",
            landAt: 6.25,
            slideDurationS: 0.65,
            equivalents: [
              {
                label: "OF COAL",
                value: "1 TONNE",
                color: "secondary",
                atS: 6.25,
                outS: 7.18,
              },
            ],
          },

          // Frame 3 — triptych: pellet | oil barrels | natural-gas flare.
          {
            layout: "left-third",
            landAt: 7.85,
            slideDurationS: 0.55,
            equivalents: [
              {
                label: "OF OIL",
                value: "149 GAL",
                color: "secondary",
                atS: 7.70,
                outS: 11.65,
              },
              {
                label: "NATURAL GAS",
                value: "17,000 FT³",
                color: "secondary",
                atS: 9.55,
                outS: 11.65,
              },
            ],
          },

          // Frame 4 — house on the right with pellet beside it (custom x positions —
          // the house composition isn't on a clean third/half boundary).
          {
            layout: "custom",
            x: 360,
            landAt: 12.85,
            slideDurationS: 0.65,
            equivalents: [
              {
                label: "HOME ELECTRICITY",
                value: "6 WEEKS",
                color: "neutral",
                x: 870,
                atS: 12.70,
                outS: 14.62,
              },
            ],
          },
        ]}
      />
    </AbsoluteFill>
  </PaletteProvider>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
